import React, { Component } from 'react'
import PropTypes from 'prop-types'

import View from '../ViewComponents/View'

const style = {
  listitem: {
    boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.50)',
    width: '100%'
  },
  emptyListItem: {
    boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.50)',
    width: '100%',
    height: '140px',
    position: 'relative'
  }
}

// const MAX_POI_COUNT_IN_LIST = 25

class PoiListComponent extends Component {

  renderListItem (categoryConfig, poi) {
    if (!categoryConfig || !poi) {
      return null
    }

    const categoryConfigToUse = typeof categoryConfig === 'string'
      ? this.props.referencedConfigs[categoryConfig]
      : categoryConfig

    const key = `listitem_${poi.id}`
    return (
      <div style={style.listitem} key={key} onClick={() => {
        // console.log(this.props.functions)
        this.props.functions.eval(categoryConfigToUse.onclick, poi)
      }}>
        <div className={categoryConfigToUse.cssClass}>
          <View
            config={categoryConfigToUse.view}
            functions={this.props.functions}
            poi={poi}
          />
        </div>
      </div>
    )
  }

  renderCategoryListItem (categoryConfig, poi) {
    if ((Object.keys(categoryConfig).includes(poi.category))) {
      return this.renderListItem(categoryConfig[poi.category].list, poi)
    }
    return null
  }

  render () {
    if (this.props.pois) {
      const referencePosition = this.props.userPosition || this.props.mapPosition
      const listItems = this.props.pois
        .filter(poi => poi.isVisible)
        .sort((a, b) => {
          const aDistance = a.getDistanceTo(referencePosition)
          const bDistance = b.getDistanceTo(referencePosition)
          return aDistance.distanceInMeter - bDistance.distanceInMeter
        })
        .map(poi => {
          return this.renderCategoryListItem(this.props.config, poi)
        })

      // const extraEmptyItem = (
      //   <div style={style.emptyListItem} key='extraEmptyItem'>
      //     <span className={s.emptyListItemInner}>
      //       &copy;
      //       <a href='https://www.tripadvisor.com/pages/terms.html' target='_blank'>TripAdvisor 2015</a>
      //     </span>
      //   </div>
      // )

      return (
        <div style={{overflow: 'hidden', width: 'calc(100vw - 20px)', height: this.props.height - 64}}>
          <div className={this.props.config.cssClass} style={{overflowY: 'auto', width: '100%', height: '100%'}}>
            {listItems}
            {/* {extraEmptyItem} */}
          </div>
        </div>
      )
    }
    return null
  }

}

PoiListComponent.propTypes = {
  pois: PropTypes.array,
  // goBack: PropTypes.func,
  // showDetails: PropTypes.func,
  userPosition: PropTypes.object,
  mapPosition: PropTypes.object,
  // onNavigateToPoi: PropTypes.func,
  height: PropTypes.number,
  functions: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  referencedConfigs: PropTypes.object
}

export default PoiListComponent



// WEBPACK FOOTER //
// ./src/components/TripAdvisor/PoiListComponent.js